/**
 * ジェネリックソートユーティリティ
 *
 * storage-management で audios / recordings / offlineEpisodes を
 * date / title / size でソートする共通ロジック。
 */

export type SortField = 'date' | 'title' | 'size'
export type SortOrder = 'asc' | 'desc'

type SortConfig<T> = {
  /** 日付として比較するキー（数値を返す） */
  dateFn: (item: T) => number
  /** タイトルとして比較する関数 */
  titleFn: (item: T) => string
  /** サイズとして比較するキー（数値を返す） */
  sizeFn: (item: T) => number
}

export const sortItems = <T>(items: T[], sortField: SortField, sortOrder: SortOrder, config: SortConfig<T>): T[] => {
  const sorted = [...items]
  sorted.sort((a, b) => {
    let comparison = 0
    switch (sortField) {
      case 'date':
        comparison = config.dateFn(a) - config.dateFn(b)
        break
      case 'title':
        comparison = config.titleFn(a).localeCompare(config.titleFn(b))
        break
      case 'size':
        comparison = config.sizeFn(a) - config.sizeFn(b)
        break
    }
    return sortOrder === 'asc' ? comparison : -comparison
  })
  return sorted
}
